import { render } from "./EditReporting.vue?vue&type=template&id=47c31466&scoped=true"
import script from "./EditReporting.vue?vue&type=script&lang=js"
export * from "./EditReporting.vue?vue&type=script&lang=js"

import "./EditReporting.vue?vue&type=style&index=0&id=47c31466&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c31466"]])

export default __exports__